import React from 'react';
import { urlWebsite } from '../../../../../../../config';
import { ParagraphStyle } from '../../ContentItem/styles';
import { EditableDiv } from 'src/pages/DashboardPages/features/PageCreator2/styles';
import { useModal } from 'src/hooks/Modal';

interface IProps {
    list: Record<string, any>;
    computer: Record<string, any>;
    mobile: Record<string, any>;
}


const DataLine = ({ item, computer, mobile }: any) => {

    const { addModal } = useModal();

    const openPopup = (content) => {
        console.log(content)
        addModal({
            title: '', content: <div className='row-to-column  gap-sm' style={{ alignItems: 'flex-start' }}>
                <div>
                    <img src={`${urlWebsite}/${item?.image}`} style={{ width: '150px', borderRadius: item?.['border-radius'] || '0px' }} />

                </div>
                <div className='column-start'>
                    {content?.title_popup ? <h2 style={{ width: '100%', textAlign: 'left', paddingBottom: '15px', fontSize: '18px', lineHeight: '24px', color: '#333' }}>{content?.title_popup}</h2> : <></>}
                    {content?.description_popup ? <p dangerouslySetInnerHTML={{ __html: content?.description_popup }} style={{ width: '100%', textAlign: 'left', fontSize: '16px', lineHeight: '24px', color: '#333' }} /> : <></>}
                </div>
            </div>, key: 'popupmodal', theme: 'whiteModalMedium'
        })

    }

    const titleConfigComputer = {
        color: item?.computer_title_color || '#fff',
        'font-size': item?.computer_title_font_size || '18px',
        'line-height': item?.computer_title_font_height || '22px',
    }

    const descriptionConfigComputer = {
        color: item?.computer_description_color || '#fff',
        'font-size': item?.computer_description_font_size || '14px',
        'line-height': item?.computer_description_font_height || '18px',
    }


    const titleConfigMobile = {
        color: item?.mobile_title_color || item?.computer_title_color || '#fff',
        'font-size': item?.mobile_title_font_size || item?.computer_title_font_size || '18px',
        'line-height': item?.mobile_title_font_height || item?.computer_title_font_height || '22px',
    }

    const descriptionConfigMobile = {
        color: item?.mobile_description_color || item?.computer_description_color || '#fff',
        'font-size': item?.mobile_description_font_size || item?.computer_description_font_size || '14px',
        'line-height': item?.mobile_description_font_height || item?.computer_description_font_height || '18px',
    }

    return <EditableDiv style={{ gap: '10px', width: '100%' }} computer={computer} mobile={mobile} onClick={() => item?.have_popup === 'yes' ? openPopup(item) : false} className='row-start'   >
        <img src={`${urlWebsite}/${item?.image}`} style={{ width: item?.width || '20px', borderRadius: item?.['border-radius'] || '0px', border: item?.border || '0px' }} />

        <div className='column-start'>
            <ParagraphStyle computer={titleConfigComputer} mobile={titleConfigMobile} dangerouslySetInnerHTML={{ __html: item?.title }} />
            <ParagraphStyle computer={descriptionConfigComputer} mobile={descriptionConfigMobile} dangerouslySetInnerHTML={{ __html: item?.description }} />
        </div>

    </EditableDiv>

}

const DataList: React.FC<IProps> = ({ list, computer, mobile }) => {

    return (<div className='row-to-column-start gap-sm'>{
        list?.map(item => <DataLine item={item} computer={computer} mobile={mobile} />)
    }

    </div>);
};
export default DataList;
